import { render, staticRenderFns } from "./main-page.vue?vue&type=template&id=f9035dd8"
import script from "./main-page.vue?vue&type=script&lang=js"
export * from "./main-page.vue?vue&type=script&lang=js"
import style0 from "./main-page.vue?vue&type=style&index=0&id=f9035dd8&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9035dd8')) {
      api.createRecord('f9035dd8', component.options)
    } else {
      api.reload('f9035dd8', component.options)
    }
    module.hot.accept("./main-page.vue?vue&type=template&id=f9035dd8", function () {
      api.rerender('f9035dd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/main-page.vue"
export default component.exports